import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import Wrapper from '../../../../components/Wrapper';
import SubscriptionOverview from '../../../../components/billings/SubscriptionOverview';
import { Button, Form } from 'antd';
import SubscriptionInput from '../../../../components/SubscriptionInput';
import PaymentMethodOverview from '../../../../components/billings/PaymentMethodOverview';
import UpcomingInvoiceOverview from '../../../../components/billings/UpcomingInvoiceOverview';
import InvoiceStatusBadge from '../../../../microcomponents/invoiceStatusBadge';
import * as React from 'react';
import { useForm } from 'antd/es/form/Form';
import useShopAttrs from '../../../../utils/hooks/useShopAttrs';
import { useMutation, useSuspenseQuery } from '@tanstack/react-query';
import { invoicesQueryOptions } from '../../../../utils/queryOptions';
import { apiV1 } from '../../../../utils/apiClient';
import SettingsSection from '../../../../components/settings/SettingsSection';
import BillingsDataForm from '../../../../components/billings/BillingsDataForm';
import PageLoader from '../../../../microcomponents/PageLoader';
import ChoosePlanModal from '../../../../components/billings/ChoosePlanModal';
import ToggleAutoRenew from '../../../../components/billings/ToggleAutoRenew';

export const Route = createFileRoute('/_authenticated/settings/billings')({
  component: RouteComponent,
  pendingComponent: () => <PageLoader />
});

function RouteComponent() {

  const [form] = useForm();

  const shopAttrs = useShopAttrs();
  const invoices = useSuspenseQuery(invoicesQueryOptions());

  async function subscribe(values: any) {
    await apiV1.post('/shop/subscription', {
      subscriptionType: values.subscription.subscriptionType,
      promoCode: values.subscription.promoCode
    });
  }

  const createNewSubscription = useMutation({
    mutationKey: ['subscription', 'create'],
    mutationFn: subscribe,
    onSuccess: () => {
      window.location.reload();
    }
  });

  /* const referralCode = useSuspenseQuery(referralCodeQueryOptions())*/

  return (
    <div>
      <SettingsSection title={'Abbonamento'}>
        <Suspense fallback={<Wrapper loading />}>
          <SubscriptionOverview />
        </Suspense>
        <Suspense>
          <ToggleAutoRenew/>
        </Suspense>
        {/*<Wrapper mt={20}>
          <h2 className={'text-lg font-medium'}>Risparmia sull'abbonamento</h2>
          <p className={'mb-4'}>Per ogni abbonamento attivato con il tuo codice, ricevi 2 mesi in regalo sul tuo abbonamento. In più, chi si iscrive grazie a te ottiene subito uno sconto del 10%.</p>
          <CopyText label={''} text={referralCode.data[0]}/>
        </Wrapper>*/}
      </SettingsSection>
      <SettingsSection title={'Metodi di pagamento'}>
        <Suspense fallback={<Wrapper loading />}>
          <PaymentMethodOverview />
        </Suspense>
      </SettingsSection>
      <SettingsSection title={'Dati di Fatturazione'}>
        <BillingsDataForm />
      </SettingsSection>
      <SettingsSection title={'Fatture'}>
        <Suspense fallback={<Wrapper loading />}>
          <UpcomingInvoiceOverview />
        </Suspense>
        <Wrapper title={'Fatture'} mt={20}>
          {invoices.data.map((invoice) => (
            <div
              onClick={() => {
                invoice?.hosted_invoice_url &&
                window.open(invoice.hosted_invoice_url);
              }}
              className={'flex mb-3 items-center justify-between p-2 rounded-md cursor-pointer'}
              key={invoice.id}
            >
              <p className={'font-medium'}>{invoice.date}</p>
              <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                <InvoiceStatusBadge invoice={invoice} />
                <p>{invoice.amount}€</p>
              </div>
            </div>
          ))}
        </Wrapper>
      </SettingsSection>
    </div>
  );
}
